<template>
  <div class="Dashboard">
    <div>
      <LastMeasure></LastMeasure>
    </div>
    <div>
      <Chart></Chart>
    </div>
    <div>
      <Table></Table>
    </div>
    <div>
      <MinMax></MinMax>
    </div>
    
    
  </div>
</template>

<script>
// @ is an alias to /src
//import Panel from '@/components/Panel.vue'
import LastMeasure from '@/components/LastMeasure.vue'
import Chart from '@/components/Chart.vue'
import MinMax from '../components/MinMax.vue'
import Table from '../components/Table.vue'

export default {
  name: 'Dashboard',
  components: {
    Chart,
    LastMeasure,
    MinMax,
    Table
  },
  data() {
    return {
     datas:[
        
        
        
      ],
      mode: "dashboard"

      
    }
  }
}
</script>
<style scoped>
  .Dashboard{
    margin: 10px;
  }
  
  
 
</style>